import { render } from "./Latest.vue?vue&type=template&id=2179cf30&scoped=true"
import script from "./Latest.vue?vue&type=script&lang=js"
export * from "./Latest.vue?vue&type=script&lang=js"

import "@/assets/css/news/index.css?vue&type=style&index=0&id=2179cf30&lang=css&scoped=true"
import "./Latest.vue?vue&type=style&index=1&id=2179cf30&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2179cf30"]])

export default __exports__